module.exports = __webpack_public_path__ + "2cfafa06f0713aa5a5269e133335bcf6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/volume-left.png
// module id = 605
// module chunks = 0